<template>
  <div class="sidemenu flex column justify-start items-center">
    <header class="sidemenu-header flex column justify-center items-center py4 px2">
      <h1 class="sidemenu-header-h1 mx0 mt0 mb2">{{ appName }}</h1>
      <div class="sidemenu-user flex column justify-center items-center">
        <span class="sidemenu-user-span flex justify-start items-center col-12"><i class="fa fa-fw fa-user" aria-hidden="true"></i>{{ username }}</span>
        <a class="sidemenu-user-a flex justify-start items-center" :href="url" target="_blank"><i class="fa fa-fw fa-wordpress" aria-hidden="true"></i><span class="sidemenu-user-a-span">{{ url }}</span></a>
      </div>
      <button class="logout-button" @click="logout">LOGOUT</button>
    </header>
    <nav class="sidemenu-nav">
      <ul class="sidemenu-list">
        <template v-for="(link, index) in links">
          <template v-if="link.icon">
            <li class="sidemenu-item">
              <router-link :to="link.path" class="sidemenu-a flex justify-start items-center">
                <span class="sidemenu-icon">
                  <div class="sidemenu-icon-before" :style="'background-color:' + link.color"></div>
                  <i :class="['fa', 'fa-fw', 'flex', 'justify-center', 'items-center', 'fa-' + link.icon]" aria-hidden="true"></i>
                </span>
                <span class="sidemenu-span block">{{ link.ja }}</span>
              </router-link>
            </li>
          </template>
        </template>
      </ul>
    </nav>
  </div>
</template>

<script>
import router from '@/router'
import MimicAmpSidebar from '@/components/mimic-amp/MimicAmpSidebar'

export default {
  name: 'app-sidemenu',
  components: {
    'mimic-amp-sidebar': MimicAmpSidebar
  },
  data: function () {
    return {
      links: router.options.routes
    }
  },
  computed: {
    appName: {
      get () { return this.$store.getters['app/name'] }
    },
    url: {
      get () { return this.$store.getters['wordpress/account/url'] }
    },
    username: {
      get () { return this.$store.getters['wordpress/account/username'] }
    }
  },
  methods: {
    logout: function () {
      this.$emit('logout')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/variables';
@import '~scss/theme';

$icon-width: 61px;
$icon-height: 56px;

.sidemenu {
  width: $app_sidemenu_width;
@if $app_header_height == 0 {
  height: 100vh;
  min-height: 100vh;
} @else {
  height: calc(100vh - #{$app_header_height});
  min-height: calc(100vh - #{$app_header_height});
}
  background-color: $--menu-item-fill;
  &-header {
    width: 100%;
    min-height: 15em;
    &-h1 {
      font-size: 1.6em;
    }
  }
  &-user {
    &-span,
    &-a {
      font-size: .8em;
    }
    &-a-span {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    & .fa.fa-fw {
      margin-right: .5em;
    }
  }
  &-nav {
    width: 100%;
    height: 100%;
    overflow: scroll;
  }
  &-list {
    margin-bottom: 3em;
  }
  &-a {
    line-height: 1;
    white-space: nowrap;
    &:hover {
      .fa.fa-fw {
        color: #fff;
        transition: $--all-transition;
      }
    }
    // &.router-link-active {
    &.router-link-exact-active {
      background-color: $--menu-item-hover-fill;
      & .fa.fa-fw {
        color: #fff;
      }
    }
    & .fa.fa-fw {
      width: $icon-width;
      height: $icon-height;
      position: relative;
      z-index: 2;
      &:before {
        font-size: 1.3em;
      }
    }
  }
  &-icon {
    width: $icon-width;
    height: $icon-height;
    position: relative;
    color: $--color-dark-white;
  }
}

.logout-button {
  margin-top: 2em;
  border-radius: 20px;
  padding: 1em 2em;
  background-color: #fff;
  font-size: .8em;
  cursor: pointer;
  outline: none;
  &:hover {
    background-color: $--color-primary;
    color: #fff;
    transition: $--all-transition;
  }
}

.sidemenu {
  &-header {
    color: #fff;
    & .logout-button {
      color: $--color-primary;
      &:hover {
        color: #fff;
      }
    }
  }
  &-a {
    color: #fff;
    &:hover,
    // &.router-link-active {
    &.router-link-exact-active {
      background-color: $--menu-item-hover-fill;
      color: $--color-primary;
      transition: $--all-transition;
      & .fa.fa-fw {
        color: $--color-primary;
        transition: $--all-transition;
      }
    }
  }
  &-icon {
    color: #fff;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/app/AppSidemenu.vue